// components/CookieBanner.js
import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Slide, useTheme, Paper } from "@mui/material";
import Cookies from "js-cookie";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const hasConsented = Cookies.get("sortlybooks_consent");
    if (!hasConsented) setVisible(true);
  }, []);

  const handleConsent = (choice) => {
    Cookies.set("sortlybooks_consent", choice, { expires: 150 });
    setVisible(false);
  };

  return (
    <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
      <Paper
        elevation={4}
        sx={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          maxWidth: 600,
          width: "90%",
          p: 2.5,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          zIndex: 1500,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          We use cookies to personalize your experience and analyze site
          traffic.{" "}
          <a
            href="/privacy"
            style={{
              color: theme.palette.primary.main,
              textDecoration: "underline",
            }}
          >
            Learn more
          </a>
        </Typography>
        <Box display="flex" justifyContent="center" gap={2} mt={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleConsent("accepted")}
            sx={{ borderRadius: "8px", px: 3 }}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => handleConsent("declined")}
            sx={{ borderRadius: "8px", px: 3 }}
          >
            Decline
          </Button>
        </Box>
      </Paper>
    </Slide>
  );
}
